import { Subscription } from 'rxjs';
import { isReportLoadingState } from './../reports.selectors';
import { CreateReportRequest } from './../reports.actions';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

@Component({
  selector: 'app-business-book-reports',
  templateUrl: './business-book-reports.component.html',
  styleUrls: ['./business-book-reports.component.css']
})
export class BusinessBookReportsComponent implements OnInit, OnDestroy {

  public form: FormGroup;
  public isLoading: boolean;
  private state$: Subscription;

  constructor(private store: Store<any>, private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      type: new FormControl('businessBook'),
      filename: new FormControl('Business List Book'),
    });

    this.state$ = this.store.pipe(select(isReportLoadingState)).subscribe((isLoading: boolean) => {
      this.isLoading = isLoading
    });
  }

  createReport() {
    this.store.dispatch(new CreateReportRequest(this.form.value))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }


}
